export default {
  mode: "PRD",
  baseUrl: {
    DEV: "/api", // 开发环境
    SIT: "/", // 测试环境
    PRD: "/answer", // 生产环境
  },
};